import { createContext } from 'react';
import { UINavPart } from './models';

export interface UINavContextData {
    parts: UINavPart[];
    setParts: (parts: UINavPart[]) => void;
}

export const UINavContext = createContext<UINavContextData | undefined>(
    undefined
);
